import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { LoginApiService } from '../../login/services/login-api.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public userDropdown: boolean = false;
  public dropDownClicked: boolean = false;
  public userName!: string;
  public userRole!: string;

  constructor(
    private router: Router,
    private userlogin: LoginApiService,
    private toasterandloader: ToasterService,
    private userService: UserService
  ) { }

  @HostListener('document:click')
  onclick(event: Event) {
    if (this.userDropdown && !this.dropDownClicked) {
      this.userDropdown = false
    }
    this.dropDownClicked = false;
  }

  public ngOnInit(): void {
    
    let userProfile = JSON.parse(localStorage.getItem('profile') || '{}');
    this.userName = userProfile?.userDetails?.firstName +' '+ (userProfile?.userDetails?.lastnName?userProfile?.userDetails?.lastnName:'');
    if (userProfile?.userDetails?.userType == 1) {
      this.userRole = 'Admin'
    } else if (userProfile?.userDetails.userType == 2) {
      this.userRole = 'Payer'
    } else if (userProfile?.userDetails?.userType == 3) {
      this.userRole = 'Provider'
    }
  }

  public showlogout():void {
    this.dropDownClicked = true
    this.userDropdown = !this.userDropdown;
  }

  public logout():void {
    this.userlogin.userLogout().subscribe({
      next: (response) => {
        if (response.status == true) {
          this.toasterandloader.isLoaderEnable(false);
          this.toasterandloader.alert.toast({
            title: 'Success',
            type: 'success',
            message: 'Logout Successfully'
          })
          localStorage.clear();
          this.userService.userProfile = null;
          this.router.navigate(['./login/user-login']);
        } else {
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: response?.message
          })
          this.toasterandloader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        // treat error
      },
    })
  }

}
